<template>
  <div class="min-h-screen bg-gradient-to-br from-green-50 via-yellow-50 to-orange-50 text-gray-800">
    <!-- 顶部导航栏 -->
    <header
      class="fixed top-0 left-0 right-0 h-[var(--header-height)] bg-black backdrop-blur-sm border-b border-purple-900 z-[100]">
      <div class="container mx-auto max-w-7xl h-full flex justify-between items-center px-3 sm:px-4">
        <router-link to="/">
          <div class="flex items-center gap-1 sm:gap-2">
            <div
              class="w-12 h-12 sm:w-12 sm:h-12   rounded-full flex items-center justify-center">
              <img src="/logo.png" alt="logo" class="w-full h-full" />
            </div>
            <!-- 在移动端隐藏应用名称 -->
            <span
              class="hidden sm:block text-xl sm:text-2xl font-bold bg-gradient-to-r from-white to-purple-600 bg-clip-text text-transparent">
              GLB
            </span>
          </div>
        </router-link>
        <!-- 电脑端导航菜单 -->
        <nav class="hidden lg:flex items-center space-x-1 ml-10">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path"
            class="px-4 py-2 rounded-lg text-gray-600 hover:text-purple-600 hover:bg-purple-50 transition-colors" :class="{
              'text-purple-600 ': $route.path === item.path,
              'text-gray-600': $route.path !== item.path,
            }">
            <div class="flex items-center gap-2">
              <component :is="item.icon" class="w-5 h-5" />
              <span class="font-medium">{{ item.name }}</span>
            </div>
          </router-link>
        </nav>
        <!-- 右侧按钮组 -->
        <div class="flex items-center gap-2 sm:gap-4">
          <!-- 在移动端调整语言切换器大小 -->
          <div class="scale-90 sm:scale-100">
            <language-switch />
          </div>
          <!-- 钱包连接按钮 -->
          <div class="wallet-connect scale-90 sm:scale-100">
            <appkit-button />
          </div>
        </div>
      </div>
    </header>



    <!-- 主内容区域添加底部导航栏的间距 -->
    <main class="min-h-screen pt-[var(--header-height)] pb-16 sm:pb-0 bg-[#050213]">
      <div class="mx-auto w-full">
        <router-view></router-view>
      </div>
     </main>
        <!-- 添加移动端底部导航栏 -->
    <nav
      class="fixed bottom-0 left-0 right-0 h-16 bg-black/80 backdrop-blur-sm border-t border-purple-900 lg:hidden z-[50]">
      <div class="h-full flex items-center justify-around px-4">
        <router-link v-for="item in mobileNavItems" :key="item.path" :to="item.path"
          class="flex flex-col items-center justify-center text-gray-600 hover:text-green-600"
          :class="{ 'text-purple-600': $route.path === item.path }">
          <component :is="item.icon" class="w-6 h-6" />
          <span class="text-xs mt-1">{{ item.name }}</span>
        </router-link>
      </div>
    </nav>

  </div>
</template>

<script setup lang="ts">
import LanguageSwitch from '@/components/LanguageSwitch.vue'
import IconProfile from '@/components/icons/IconProfile.vue'
import { Home, Repeat, Pickaxe,  BookText, Cable } from 'lucide-vue-next'
import { computed } from 'vue'
import type { Component } from 'vue'
import { useI18n } from 'vue-i18n'

interface NavItem {
  name: string
  path: string
  icon: Component
}

const { t } = useI18n()

// 导航项配置改为计算属性
const navItems = computed<NavItem[]>(() => [
  {
    name: t('common.navigation.home'),
    path: '/',
    icon: Home,
  },
  // {
  //   name: t('common.navigation.book'),
  //   path: '/book',
  //   icon: BookText,
  // },
  {
    name: t('common.navigation.trade'),
    path: '/trade',
    icon: Repeat,
  },
  {
    name: t('common.navigation.start'),
    path: '/start',
    icon: Cable,
  },
  {
    name: t('common.navigation.miner'),
    path: '/miner',
    icon: Pickaxe,
  },
  {
    name: t('common.navigation.profile'),
    path: '/profile',
    icon: IconProfile,
  },
])

// 移动端导航项也改为计算属性
const mobileNavItems = computed<NavItem[]>(() =>
  navItems.value.map((item) => {
    return {
      ...item,
      name:
        item.path === '/start'
          ? t('common.navigation.mobile.start')
          : item.path === '/miner'
          ? t('common.navigation.mobile.miner')
          : item.name,
    }
  }),
)
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .nav-item i {
    @apply text-xl;
  }
}

@media screen and (max-width: 480px) {
  .logo span {
    @apply hidden;
  }
}

/* 添加过渡效果 */
.router-link-active,
.router-link-active svg,
a:hover,
a:hover svg {
  @apply transition-colors duration-200;
}

/* 确保内容区域不被底部导航栏遮挡 */
@media (max-width: 1024px) {
  main {
    padding-bottom: 4rem;
    /* 64px */
  }
}

/* 电脑端导航项悬停效果 */
@media (min-width: 1024px) {
  nav a:hover {
    @apply transform -translate-y-0.5;
  }
}
</style>
